import forge from 'node-forge';

export function periodicSyncStatsEncryption(payload: any, publicKeyPem: string) {
  try {
    if (!payload || !publicKeyPem) {
      throw new Error('Payload and public key are required');
    }

    const aesKey = forge.random.getBytesSync(32); // 256-bit AES key
    const iv = forge.random.getBytesSync(12); // 12-byte IV
    const payloadString = JSON.stringify(payload);

    // Encrypt the payload using AES-GCM
    const cipher = forge.cipher.createCipher('AES-GCM', aesKey);
    cipher.start({ iv: iv, tagLength: 16 * 8 }); // 128-bit (16-byte) tag length
    cipher.update(forge.util.createBuffer(payloadString, 'utf8'));
    const encryptionSuccess = cipher.finish();

    if (!encryptionSuccess) {
      throw new Error('AES encryption failed');
    }

    // Extract encrypted data and authentication tag
    const encryptedData = cipher.output.getBytes(); // Encrypted payload
    const tag = cipher.mode.tag.getBytes(); // Authentication tag

    // Concatenate encrypted data and tag to match Node.js crypto output
    const finalEncryptedData = encryptedData + tag;

    // Encrypt the AES key using RSA-OAEP with SHA-256
    const rsaPublicKey = forge.pki.publicKeyFromPem(publicKeyPem);
    const encryptedAESKey = rsaPublicKey.encrypt(aesKey, 'RSA-OAEP', {
      md: forge.md.sha256.create(), // Use SHA-256 for OAEP padding
    });

    return {
      encryptedKey: forge.util.encode64(encryptedAESKey),
      encryptedData: forge.util.encode64(finalEncryptedData),
      iv: forge.util.encode64(iv),
    };
  } catch (error) {
    console.error('Encryption error:', error);
    return null;
  }
}
